import { AssetPurposeTypeString, SendAssetPurposeMappedEnum } from '@tassat/common-definitions';

export const SendAssetPurposeMapped = [
    {
        label: AssetPurposeTypeString.settlement_of_off_platform_digital_asset_transaction,
        value: SendAssetPurposeMappedEnum.SETTLEMENT_OF_OFF_PLATFORM_DIGITAL_ASSET_TRANSACTION
    },
    {
        label: AssetPurposeTypeString.payment_for_goods_services_or_other_obligations,
        value: SendAssetPurposeMappedEnum.PAYMENT_FOR_GOODS_SERVICES_OR_OTHER_OBLIGATIONS
    },
    {
        label: AssetPurposeTypeString.intercompany_transfer,
        value: SendAssetPurposeMappedEnum.INTERCOMPANY_TRANSFER
    },
    {
        label: AssetPurposeTypeString.investment_purposes,
        value: SendAssetPurposeMappedEnum.INVESTMENT_PURPOSES
    },
    {
        label: AssetPurposeTypeString.other,
        value: SendAssetPurposeMappedEnum.OTHER
    }
];